import type { AlainAuthConfig } from '@delon/util/config';
import type { SetRequired } from 'type-fest';
// import { AUTH_DEFAULT_CONFIG } from '@delon/auth';

export function getAlainAuthConfig(config: SetRequired<AlainAuthConfig, 'store_key'>) {
  const defaultAuthOptions: AlainAuthConfig = {
    // store_key: `_token`,
    // token_invalid_redirect: true,
    // token_exp_offset: 10,
    token_send_key: `Authorization`,
    // token_send_template: '${token}',
    // token_send_place: 'header',
    // login_url: '/login',
    // refreshTime: 3000,
    // refreshOffset: 6000,
    // ignores: [/\/assets\//],
  };
  const res: AlainAuthConfig = { ...defaultAuthOptions, ...config };
  return res;
}
